import { render, staticRenderFns } from "./EmployeePaymentBankInfo.vue?vue&type=template&id=3c1c2aa9"
import script from "./EmployeePaymentBankInfo.vue?vue&type=script&lang=js"
export * from "./EmployeePaymentBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports